export const ROUTE_WITH_TAB = {
	dashboard: "Dashboard",
	"my-fleet": "My Fleet",
	reports: "Annual Emission Verification",
	"manage-user-details": "Help",
	"port-codes": "Annual Emission Verification",
	"cii-calculations": "Annual Emission Verification",
	seemp: "Monitoring Plans",
	support: "Support",
	"manage-account": "Account",
	admin: "Admin",
	eventlogs: "Admin",
	"bulk-export": "Admin",
	"unsatisfactory-cii-ratings-vessel-export": "Admin",
	"export-eu-mrv-data": "Annual Emission Verification",
	"feu-compliance-balance-reports": "Annual Emission Verification",
	"uk-ets-annual-emission-report": "Annual Emission Verification",
	"plan-verification": "Annual Emission Verification",
	"eumrv-company-emission-verification-report": "Annual Emission Verification",
	"company-verification-report": "Annual Emission Verification",
};

export const APP_TITLE = "Emissions Reporter Portal";
export const WELCOME_MESSAGE =
	"Upgrade to ERP7.0 is now complete. You can continue using your existing login credentials.";
